import $ from 'jquery';
import axios from 'axios';

/**
 * Soumission du formulaire de connexion Neosafe
 * @param e
 */
const submit = (e) => {
    console.log("reset password submit");
    e.preventDefault();
    const $form = $(e.currentTarget),
        $btn_submit = $('#submit-neosafe-btn'),
        $key_field = $('#neosafe_reset_key'),
        $password_field = $("#neosafe_password"),
        $password_confirm_field = $("#neosafe_password_confirm"),
        $alert_error = $("#alert-error"),
        $form_wrapper = $('#the-form-wrapper'),
        $alert_pwd_not_secure = $("#alert-pwd-not-secure"),
        $alert_bad_confirm = $("#alert-bad-confirm"),
        $alert_bad_code = $("#alert-bad-code"),
        $sucess_message = $('#success-redirect-message'),
        data = {
            'neosafe_reset_key' : $key_field.val(),
            'neosafe_password': $password_field.val(),
            'neosafe_password_confirm': $password_confirm_field.val()
        };

    $alert_error.hide();
    $alert_pwd_not_secure.hide();
    $alert_bad_confirm.hide();
    $alert_bad_code.hide();
    $btn_submit.attr("disabled", true);

    axios.put($form.attr("action"), data)
        .then((response) => {
            if (response.data.success) {
                $form_wrapper.hide();
                $sucess_message.show();
            } else {
                switch(response.data.error){
                    case "confirmation_failed" :
                        $alert_bad_confirm.show();
                        $password_confirm_field.val("").focus();
                        break;
                    case "precondition_failed" :
                        $alert_pwd_not_secure.show();
                        $password_field.val("").focus();
                        $password_confirm_field.val("");
                        break;
                    case "bad_code" :
                        $alert_bad_code.show();
                        $password_field.val("");
                        $password_confirm_field.val("");
                        break;
                    default :
                        $alert_error.show();
                        break;
                }
            }
        })
        .catch(() => $alert_error.show())
        .finally(() => $btn_submit.removeAttr("disabled"));
}

export {submit};